import React from 'react';
import {
  ActionsChatZone,
  IndividualActiveContactZone,
  LabelTitle
} from './styled';

import ContactActiveModal from '../Contact/ContactActiveModal';
import { BsFillPeopleFill } from 'react-icons/bs';
import { useQueueChatPauseContext } from 'hooks/useQueuePauseChatServicePanel';
import { useSelector } from 'react-redux';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import { toast } from 'react-toastify';
import TransferManyButton from 'views/Monitoring/Chat/conversation/components/TransferManyButton';

export const IndividualActiveContact = ({
  selectedChats,
  setSelectedChats,
  getConversations
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const { messageSendingBlocked, queuesChatLoggedValues } =
    useQueueChatPauseContext();
  const [showModalActiveContact, setShowModalActiveContact] =
    React.useState(false);

  const openModalContactActive = () => {
    if (!messageSendingBlocked && queuesChatLoggedValues.length > 0) {
      setShowModalActiveContact(true);
      return;
    }
    toast.warning(
      'Você precisa estar logado em uma fila e não estar em pausa para acessar os contatos ativos',
      {
        autoClose: 4000,
        closeOnClick: true
      }
    );
  };

  return (
    <>
      <IndividualActiveContactZone>
        <LabelTitle>Mensagens</LabelTitle>
        <ActionsChatZone>
          <TransferManyButton
            setSelectedRows={setSelectedChats}
            getConversations={getConversations}
            id={selectedChats}
            altIcon={true}
          />
          {verifyRoles(['ACTIVE_CONTACT']) && (
            <BsFillPeopleFill
              size={20}
              type="button"
              color={systemConfiguration.primary_color}
              style={{
                opacity:
                  queuesChatLoggedValues.length === 0 || messageSendingBlocked
                    ? '0.6'
                    : '1',
                cursor:
                  messageSendingBlocked || queuesChatLoggedValues.length === 0
                    ? 'not-allowed'
                    : 'pointer'
              }}
              onClick={openModalContactActive}
            />
          )}
        </ActionsChatZone>
      </IndividualActiveContactZone>

      <ContactActiveModal
        className="modal-lg"
        show={showModalActiveContact}
        onModalToggle={setShowModalActiveContact}
      />
    </>
  );
};
